import React, { useEffect, useState } from 'react'
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { Button as ButtonB } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
    Button, 
    Text,
    Loader, 
    View,
} from "@aws-amplify/ui-react";
import { API, Auth } from "aws-amplify";
import axios from 'axios';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import FormPagos from '../FormPagos';
import '../../App.css'
import { publishMessage } from '../../graphql/mutations';
import { onMessageReceived } from '../../graphql/subscriptions';
import { useTramiteDataGeneral } from '../../TramiteContext'
import ResumenCard from './ResumenCard';
import Swal from 'sweetalert2'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { AutoGraphTwoTone } from '@mui/icons-material';

const steps = ['Información', 'Contaminantes en el suelo', 'Contaminantes en el agua', 'Formas de pago'];

export const FormEmisionCon = () => {
    const { data, updateData, setCalculo, setDeclaracion } = useTramiteDataGeneral()
    const [isLoading, setIsLoading] = useState(false);
    const [infoRFC, setInfoRFC] = useState({});
    const [authToken, setAuthToken] = useState('')
    const [taskToken, setTaskToken] = useState('')
    const [metodoPago, setMetodoPago] = useState('pago1');
    const [declaracionesImp, setDeclaracionesImp] = useState([]);
    const [calculoData, setCalculoData] = useState({})
    const [recalc, setRecalc] = useState(true)
    const [loading, setLoading] = useState(false);
    //alerts
    const [ExitoLiga, setExitoLiga] = useState(false)
    const [FalloLiga, setFalloLiga] = useState(false)


    //const { Formik } = formik;
    const validationSchema = yup.object().shape({
        RFC: yup.string().required("Este Campo es Obligatorio").matches(/^([A-ZÑ\x26]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d]{3})?$/, 'RFC inválido'),
        anno: yup.number().required("Este Campo es Obligatorio").positive("Solo Numeros positivos").max(9999, "Valor no valido"),
        MesInicio: yup.number().required("Este Campo es Obligatorio"),
        MesFinal: yup.number().required("Este Campo es Obligatorio"),
        SaldoFavor: yup.number(),
        Compensacion: yup.number(),
        Multas: yup.number(),
        metrosCuadradosSuelo: yup.number().required("Este Campo es Obligatorio").min(0, 'No se aceptan numero negativos'),
        SBen: yup.number().min(0, 'No se aceptan numero negativos'),
        STol: yup.number().min(0, 'No se aceptan numero negativos'),
        SEti: yup.number().min(0, 'No se aceptan numero negativos'),
        SInd: yup.number().min(0, 'No se aceptan numero negativos'),
        SXil: yup.number().min(0, 'No se aceptan numero negativos'),
        SBenz: yup.number().min(0, 'No se aceptan numero negativos'),
        SDib: yup.number().min(0, 'No se aceptan numero negativos'),
        SBena: yup.number().min(0, 'No se aceptan numero negativos'),
        SBenb: yup.number().min(0, 'No se aceptan numero negativos'),
        SNiq: yup.number().min(0, 'No se aceptan numero negativos'),
        SArs: yup.number().min(0, 'No se aceptan numero negativos'),
        SBenk: yup.number().min(0, 'No se aceptan numero negativos'),
        SBar: yup.number().min(0, 'No se aceptan numero negativos'),
        SBer: yup.number().min(0, 'No se aceptan numero negativos'),
        SCad: yup.number().min(0, 'No se aceptan numero negativos'),
        SCro: yup.number().min(0, 'No se aceptan numero negativos'),
        SMer: yup.number().min(0, 'No se aceptan numero negativos'),
        SPla: yup.number().min(0, 'No se aceptan numero negativos'),
        SPlo: yup.number().min(0, 'No se aceptan numero negativos'),
        SSel: yup.number().min(0, 'No se aceptan numero negativos'),
        STal: yup.number().min(0, 'No se aceptan numero negativos'),
        SVan: yup.number().min(0, 'No se aceptan numero negativos'),
        metrosCubicosAgua: yup.number().min(0, 'No se aceptan numero negativos'),
        ASst: yup.number().min(0, 'No se aceptan numero negativos'),
        AGrac: yup.number().min(0, 'No se aceptan numero negativos'),
        ADbo: yup.number().min(0, 'No se aceptan numero negativos'),
        ANit: yup.number().min(0, 'No se aceptan numero negativos'),
        AFos: yup.number().min(0, 'No se aceptan numero negativos'),
        AArs: yup.number().min(0, 'No se aceptan numero negativos'),
        ACad: yup.number().min(0, 'No se aceptan numero negativos'),
        ACia: yup.number().min(0, 'No se aceptan numero negativos'),
        ACob: yup.number().min(0, 'No se aceptan numero negativos'),
        ACro: yup.number().min(0, 'No se aceptan numero negativos'),
        AMer: yup.number().min(0, 'No se aceptan numero negativos'),
        ANiq: yup.number().min(0, 'No se aceptan numero negativos'),
        APlo: yup.number().min(0, 'No se aceptan numero negativos'),
        AZin: yup.number().min(0, 'No se aceptan numero negativos'),

    });
    const formik = useFormik({
        initialValues: {
            RFC: '',
            anno: '',
            MesInicio: '',
            MesFinal: '',
            SaldoFavor: '',
            Compensacion: '',
            Multas: '',
            metrosCuadradosSuelo: '',
            SBen: '',
            STol: '',
            SEti: '',
            SInd: '',
            SXil: '',
            SBenz: '',
            SDib: '',
            SBena: '',
            SBenb: '',
            SNiq: '',
            SArs: '',
            SBenk: '',
            SBar: '',
            SBer: '',
            SCad: '',
            SCro: '',
            SMer: '',
            SPla: '',
            SPlo: '',
            SSel: '',
            STal: '',
            SVan: '',
            metrosCubicosAgua: '',
            ASst: '',
            AGrac: '',
            ADbo: '',
            ANit: '',
            AFos: '',
            AArs: '',
            ACad: '',
            ACia: '',
            ACob: '',
            ACro: '',
            AMer: '',
            ANiq: '',
            APlo: '',
            AZin: '',
        },
        onSubmit: values => {
            //alert(JSON.stringify(values, null, 2));
        },
        validationSchema
    });


    let valuesAgua = [
        formik.values.ASst,
        formik.values.AGrac,
        formik.values.ADbo,
        formik.values.ANit,
        formik.values.AFos,
        formik.values.AArs,
        formik.values.ACad,
        formik.values.ACia,
        formik.values.ACob,
        formik.values.ACro,
        formik.values.AMer,
        formik.values.ANiq,
        formik.values.APlo,
        formik.values.AZin
    ];

    let valuesSuelo = [
        formik.values.SBen,
        formik.values.STol,
        formik.values.SEti,
        formik.values.SInd,
        formik.values.SXil,
        formik.values.SBenz,
        formik.values.SDib,
        formik.values.SBena,
        formik.values.SBenb,
        formik.values.SNiq,
        formik.values.SArs,
        formik.values.SBenk,
        formik.values.SBar,
        formik.values.SBer,
        formik.values.SCad,
        formik.values.SCro,
        formik.values.SMer,
        formik.values.SPla,
        formik.values.SPlo,
        formik.values.SSel,
        formik.values.STal,
        formik.values.SVan
    ];

    const validarRFC = async (RFC) => {
        //MOOA910828HM8 : for testing 
        let user = await Auth.currentAuthenticatedUser();
        setLoading(true);
        const variables = {
            "id": "123",
            "payload": {
                "validationRequested": true,
                "data": {
                    "id": "IECSA",
                    "rfc": RFC
                },
                "type": "declaraciones"
            }
        };
        const Data = await API.graphql({
            query: publishMessage,
            variables: {
                ...variables,
                payload: JSON.stringify(variables.payload),
            },

        });
        console.log("A VALIDATE", Data);
    }

    const declaracionesAnteriores = async () => {
        setLoading(true);
        const variables = {
            "id": "123",
            "payload": {
                "data": {
                    "periodicidad": {
                        "id": infoRFC.periodicidad.id,//1,
                        "tipoPeriodo": infoRFC.periodicidad.tipoPeriodo,//"MENSUAL",
                        "esActivo": true,
                        "valor": infoRFC.periodicidad.valor
                    },
                    "rfc": "MOOA910828HM8",
                    "padron": {
                        "id": infoRFC.padron.id,//58,
                        "nombre": infoRFC.padron.nombre,//"IMPUESTO DE EMISIÓN DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",
                        "activo": infoRFC.padron.activo,//true
                        "clave": "IECSA",//infoRFC.padron.clave
                    },
                    "mdCaracteristicaId": infoRFC.mdCaracteristicaId//67666
                },
                authToken,
                taskToken,
                type: "declaraciones",
            },
        }
        console.log("Variables", variables);
        const Data = await API.graphql({
            query: publishMessage,
            variables: {
                ...variables,
                payload: JSON.stringify(variables.payload),
            },
        });

        console.log("A VALIDATE DECL", Data);
    }
    const validateField = (value, setString = true) => {
        return value === "" || value === 0 ? null : setString ? `${value}` : Number(value)
    }
    const calculoImpuesto = async () => {
        const data = formik.values
        console.log("DATA---", data);
        const variables = {
            "id": "123",

            "payload": {
                "data": {
                    "generaEstadoCuenta": true,
                    "periodicidad": { "id": 1, "tipoPeriodo": "MENSUAL", "valor": 12 },
                    "padron": {
                        "id": 58,
                        "nombrePadron": infoRFC.padron.nombre,//"IMPUESTO DE EMISIÓN DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",
                        "clave": "IECSA"
                    },
                    "mdCaracteristicaId": infoRFC.mdCaracteristicaId,//67511,
                    "rfc": validateField(data.RFC),//RFC del contribuyente (Interno) 
                    "annio": validateField(data.anno, false),//Año del periodo declarado (Usuario) 
                    "mesInicio": validateField(Number(data.MesInicio), false),//Mes inicio del periodo declarado (Usuario) 
                    "mesFin": validateField(Number(data.MesFinal), false),//Mes fin del periodo declarado (Usuario) 
                    "compensacion": validateField(data.Compensacion),//Importe por compensación (Usuario) 
                    "saldoAFavor": validateField(data.SaldoFavor),//Importe por saldo a favor (Usuario) 

                    "multas": validateField(data.Multas),//Importe por multas (Usuario) 

                    "metrosCuadradosSuelo": validateField(data.metrosCuadradosSuelo),//Superficie de suelo contaminada(Usuario) 

                    "metrosCubicosAgua": validateField(data.metrosCubicosAgua),//Volumen de agua contaminada(Usuario) 

                    "SBen": validateField(data.SBen),//Cantidad de SBen en el suelo contaminado(Usuario) 

                    "STol": validateField(data.STol),//Cantidad de STol en el suelo contaminado(Usuario) 

                    "SEti": validateField(data.SEti),//Cantidad de SEti en el suelo contaminado(Usuario) 

                    "SInd": validateField(data.SInd),//Cantidad de Indeno (1,2,3-cd) pireno en el suelo contaminado(Usuario) 

                    "SXil": validateField(data.SXil),//Cantidad de  SXil suma de isómeros en el suelo contaminado(Usuario) 

                    "SBenz": validateField(data.SBenz),//Cantidad de Benzo[a] ireno en el suelo contaminado(Usuario) 

                    "SDib": validateField(data.SDib),//Cantidad de Dibenzo[ah]antraceno en el suelo contaminado(Usuario) 

                    "SBena": validateField(data.SBena),//Cantidad de Benzo [a] antraceno en el suelo contaminado(Usuario) 

                    "SBenb": validateField(data.SBenb),//Cantidad de Benzo [b] fluoranteno en el suelo contaminado(Usuario) 

                    "SNiq": validateField(data.SNiq),//Cantidad de SNiq en el suelo contaminado(Usuario) 

                    "SArs": validateField(data.SArs),//Cantidad de Arsénico en el suelo contaminado(Usuario) 

                    "SBenk": validateField(data.SBenk),//Cantidad de Benzo [k] fluoranteno en el suelo contaminado(Usuario) 

                    "SBar": validateField(data.SBar),//Cantidad de SBar en el suelo contaminado(Usuario) 

                    "SBer": validateField(data.SBer),//Cantidad de SBer en el suelo contaminado(Usuario) 

                    "SCad": validateField(data.SCad),//Cantidad de SCad en el suelo contaminado(Usuario) 

                    "SCro": validateField(data.SCro),//Cantidad de Cromo Hexavalente en el suelo contaminado(Usuario) 

                    "SMer": validateField(data.SMer),//Cantidad de SMer en el suelo contaminado(Usuario) 

                    "SPla": validateField(data.SPla),//Cantidad de SPla en el suelo contaminado(Usuario) 

                    "SPlo": validateField(data.SPlo),//Cantidad de SPlo en el suelo contaminado(Usuario) 

                    "SSel": validateField(data.SSel),//Cantidad de SSel en el suelo contaminado(Usuario) 

                    "STal": validateField(data.STal),//Cantidad de STal en el suelo contaminado(Usuario) 

                    "SVan": validateField(data.SVan),//Cantidad de SVan en el suelo contaminado(Usuario) 

                    "ASst": validateField(data.ASst),//Cantidad de Sólidos Suspendidos Totales en el agua contaminada(Usuario) 

                    "AGrac": validateField(data.AGrac),//Cantidad de Grasas Aceites en el agua contaminada(Usuario) 

                    "ADbo": validateField(data.ADbo),//Cantidad de Demanda Bioquímica de Oxígeno 5 en el agua contaminada(Usuario) 

                    "ANit": validateField(data.ANit),//Cantidad de Nitrogeno Total en el agua contaminada(Usuario) 

                    "AFos": validateField(data.AFos),//Cantidad de 25 Fósforo Total en el agua contaminada(Usuario) 

                    "AArs": validateField(data.AArs),//Cantidad de Arsénico en el agua contaminada(Usuario) 

                    "ACad": validateField(data.ACad),//Cantidad de SCad en el agua contaminada(Usuario) 

                    "ACia": validateField(data.ACia),//Cantidad de Cianuro en el agua contaminada(Usuario) 

                    "ACob": validateField(data.ACob),//Cantidad de Cobre en el agua contaminada(Usuario) 

                    "ACro": validateField(data.ACro),//Cantidad de Cromo en el agua contaminada(Usuario) 
                    "AMer": validateField(data.AMer),//Cantidad de SMer en el agua contaminada(Usuario) 
                    "ANiq": validateField(data.ANiq),//Cantidad de Níquel en el agua contaminada(Usuario) 
                    "APlo": validateField(data.APlo),//Cantidad de SPlo en el agua contaminada(Usuario) 
                    "AZin": validateField(data.AZin),//Cantidad de Zinc en el agua contaminada(Usuario) 
                },
                "recalculate": recalc,
                authToken,
                taskToken,
                type: "declaraciones",
            }
        }
        console.log("---Variables", variables);
        const Data = await API.graphql({
            query: publishMessage,
            variables: {
                ...variables,
                payload: JSON.stringify(variables.payload),
            },
        });
        setRecalc(true)
    }
    //childFunctionRef.current = calculoImpuesto;
    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Get the day and pad with leading zero if necessary
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Get the month (0-11) and add 1, then pad with leading zero
        const year = today.getFullYear(); // Get the full year (4 digits)

        return `${day}/${month}/${year}`;
    }

    const GenerarLigaPago = async () => {
        
        if(formik.values.metrosCuadradosSuelo == "" && formik.values.metrosCubicosAgua == "") {
            Swal.fire({
                title: 'Error!',
                text: 'Llena los datos de contanimantes del suelo o el agua',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            })
        }
        if(formik.values.metrosCubicosAgua != "" || formik.values.metrosCuadradosSuelo != "") {
           const fieldsFilledAgua = Object.values(valuesAgua).filter(value => value !== "").length;
           const fieldsFilledSuelo = Object.values(valuesSuelo).filter(value => value !== "").length;
           console.log("rem",fieldsFilledAgua,fieldsFilledSuelo);
           if(fieldsFilledAgua <=0 && fieldsFilledSuelo <= 0) {
                Swal.fire({
                    title: 'Error!',
                    text: 'Llena al menos dos 2 de contanimantes del suelo o el agua',
                    icon: 'error',
                    confirmButtonText: 'Cerrar'
                })
                return
           }
           console.log(fieldsFilledAgua);
        }
        const user = await Auth.currentAuthenticatedUser();
        console.log(user);
        // metodoPago : pago1 : card - pago2 : - pago3 :
        // prepara conceptos con lo de calculo
        const conceptos = calculoData.conceptos?.map(cp => {
            return { clave: cp.clave, concepto: cp.descripcion, importe: cp.importe }
        })
        //preparar otras referencias
        const otrasRef = calculoData.estadoCuenta?.referencias?.map(referencia => {
            return { banco: referencia.recaudacion, convenio: "NO HAY DATO", referencia: referencia.referencia }
        })
        const variables = metodoPago === "pago1" ?
            {
                "id": "123",
                "payload": {
                    "paymentMethod": "card",
                    "email": user.attributes.email,
                    "tramite": infoRFC.padron.nombre,//"IMPUESTO A LA EMISION DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",
                    "reference": `${calculoData.estadoCuenta?.referencias[0].referencia}`,//"202300011471739766260",
                    "monto": `${calculoData.calculos?.total}`,//"0.01",
                    authToken,
                    taskToken,
                    type: "declaraciones",
                }
            }
            :
            metodoPago === "pago2" ?
                {
                    "id": "123",
                    "payload": {

                        "paymentMethod": "spei",
                        "data": {

                            "loteId": `${calculoData.estadoCuenta?.loteId}`,

                            "total_pagar": calculoData.calculos?.total,

                            "tramite": infoRFC.padron.nombre,//"IMPUESTO A LA EMISION DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",

                            "rfc": infoRFC.rfc,

                            "fecha_generacion": getCurrentDate(),

                            "fecha_vigencia": "19/10/2022",

                            "contribuyente": `${data.infoRFC.nombre}`,

                            "referencia": `${calculoData.estadoCuenta?.referencias[0].referencia}`,

                            "otras_referencias": otrasRef

                        },

                        "email": user.attributes.email,

                        "procedure": "referencia_pago"

                    }

                }
                :
                {
                    "id": "123",
                    "payload": {
                        "paymentMethod": "spei",
                        "data": {
                            "contribuyente": `${data.infoRFC.nombre}`,

                            "fecha_generacion": "19/10/2022",

                            "rfc": infoRFC.rfc,

                            "fecha_vigencia": "19/10/2022",

                            "movimiento": "Declaracion complementaria",

                            "num_empleados": 250,

                            "instrumento_pago": "referencia bancaria",

                            "base_impuesto": "5%",

                            "periodo": "Septiembre - Octubre",

                            "tipo_declaracion": "Mensual",

                            "otros_conceptos": conceptos,

                            "total_pagar": "60.00"

                        },

                        "email": user.attributes.email,

                        "procedure": "presupuesto"

                    },
                };
        const Data = await API.graphql({
            query: publishMessage,
            variables: {
                ...variables,
                payload: JSON.stringify(variables.payload),
            },
        });
        console.log("Data :>> ", Data, variables);
    }

    const registroPagoSEI = async () => {
        const variables = {
            "id": "123",
            "payload": {
                "data": {
                    "email": "david.sosa@g-tech.io",
                    "reference": "202300011471739766260",
                    "response": "approved",
                    "foliocpagos": "684776968",
                    "auth": "170826",
                    "cd_response": "00",
                    "cd_error": "",
                    "nb_error": "",
                    "time": "13:17:38",
                    "date": "21/09/2023",
                    "nb_company": "GOBIERNO DEL ESTADO DE DURANGO CSS",
                    "nb_merchant": "9142283 GOB DURANGO DIGITAL",
                    "cc_type": "DEBITO/COMPROPAGO/Visa",
                    "tp_operation": "VENTA",
                    "cc_name": "",
                    "cc_number": "5740",
                    "cc_expmonth": "09",
                    "cc_expyear": "28",
                    "amount": "0.01",
                    "emv_key_date": "",
                    "id_url": "4LT7W8F1",
                    "st_cr": "0",
                    "cc_mask": "421747XXXXXX5740",
                    "datos_adicionales": {
                        "data": {
                            "label": "Tramite",
                            "value": "IMPUESTO A LA EMISION DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA"
                        }
                    }
                },
                authToken,
                taskToken,
                type: "declaraciones",
            }
        }
        const Data = await API.graphql({
            query: publishMessage,
            variables: {
                ...variables,
                payload: JSON.stringify(variables.payload),
            },
        });
    }

    const [message, setMessage] = useState(null);

    useEffect(() => {
        const subscription = API.graphql({ query: onMessageReceived, variables: { id: '123' } })
            .subscribe({
                next: (event) => {
                    const receivedMessage = event.value.data.onMessageReceived;
                    

                    //parse json on payload response. - authToken - taskToken --- rfc
                    setMessage(receivedMessage);
                    const dataRec = JSON.parse(receivedMessage.payload)
                    setLoading(false);
                    console.log("DATA rec", dataRec);
                    if (dataRec?.procedure === "paymentUrl") {
                        /*
                            {

                                    "payload": {

                                    "procedure": "paymentUrl",

                                    "response": {

                                        "cd_response": "success",

                                        "nb_response": "",

                                        "nb_url": "https://u.mitec.com.mx/p/i/2KGJ6TDQ"

                                    }

                                    },

                                    "id": "123"

                                }


                            {

                                    "payload": {

                                    "procedure": "paymentUrl",

                                    "response": {

                                        "cd_response": "error",

                                        "nb_response": "La peticion es invalida ORA-06502: PL/SQL: numeric or value error: character to number conversion error",

                                        "nb_url": ""

                                    }

                                    },

                                    "id": "123"

                                }
                        */
                        //hacer handle de error y abrir cuando este bien

                        if (dataRec.response.cd_response === "error") {
                            AlertsAction("error")
                            return
                        }
                        if (dataRec.response.cd_response === "success") {
                            AlertsAction("success")
                            window.open(dataRec.response.nb_url)
                        }


                    }
                    if (dataRec.Procedure === "referencia_pago" || dataRec.Procedure === "presupuesto") {
                        window.open(dataRec.TXTBody);
                        return
                    }
                    setTaskToken(dataRec.taskToken)
                    if (dataRec.step === "validarRfc") {
                        /*
                        {
                            "razonSocial": "ANA KAREN MORA ORTIZ",
                            "periodicidad": {
                                "id": 1,
                                "tipoPeriodo": "MENSUAL",
                                "esActivo": true,
                                "valor": 12
                            },
                            "rfc": "MOOA910828HM8",
                            "nombre": "ANA KAREN MORA ORTIZ",
                            "estatus": "ACTIVO",
                            "tipoCalle": "CALLE",
                            "calle": "JAZMIN",
                            "numeroExterior": "202",
                            "numeroInterior": null,
                            "colonia": "LA VIRGEN",
                            "codigoPostal": "34049",
                            "localidad": "DURANGO",
                            "municipio": "DURANGO",
                            "esPersonaAmparada": false,
                            "padron": {
                                "id": 58,
                                "nombre": "IMPUESTO DE EMISIÓN DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",
                                "activo": true
                            },
                            "mdCaracteristicaId": 67666
                        }
                        */
                        setAuthToken(dataRec.authToken)
                        setInfoRFC(dataRec.response)
                        updateData({ ...data, infoRFC: dataRec.response });
                    }
                    if (dataRec.step === "buscarDeclaraciones") {
                        // handleNext()
                        /**
                        {
                                "id": 2,
                                "mdCaracteristicasImpId": 67511,
                                "adMovimientoId": 1186,
                                "periodo": 2023,
                                "periodoInicio": 9,
                                "periodoFin": 9,
                                "tipoDeclaracion": 2,
                                "fechaDeclaracion": "2023-09-04",
                                "mcTramiteId": 545813,
                                "mcTransaccionId": 622254,
                                "impuesto": 500,
                                "fomentoEducacion": 200,
                                "actualizacion": 0,
                                "recargos": 0,
                                "multas": null,
                                "compensacion": 0,
                                "saldoFavor": 0,
                                "total": 700,
                                "esComplementaria": true,
                                "mdDetallesDeclaracionesDTO": [
                                    {
                                        "id": 3,
                                        "mdDeclaracionId": 2,
                                        "mdCatalogoValoresImpId": 2,
                                        "descripcion": "METROS_CUADRADOS",
                                        "valor": "20"
                                    },
                                    {
                                        "id": 4,
                                        "mdDeclaracionId": 2,
                                        "mdCatalogoValoresImpId": 3,
                                        "descripcion": "SUB_TOLUENO",
                                        "valor": "10"
                                    }
                                ]
                            } 
                         */
                        console.log("-----", data);
                        setDeclaracionesImp(dataRec.response.declaracionesImpPortal)
                        setDeclaracion(dataRec.response.declaracionesImpPortal)
                        //updateData({ ...data, infoRFC: infoRFC, declaracionesImp: dataRec.response })
                    }
                    if (dataRec.step === "calculo") {
                        /*
                            {
                                    "padron": {
                                        "id": 58,
                                        "clave": "IECSA"
                                    },
                                    "calculos": {
                                        "impuestoSuelo": 0,
                                        "impuestoAgua": 0,
                                        "impuestoDeterminado": 0,
                                        "fomentoEducativo": 0,
                                        "actualizacion": 0,
                                        "recargos": 0,
                                        "multas": 0,
                                        "subtotal1": 0,
                                        "subtotal2": 0,
                                        "total": 0,
                                        "saldoAFavor": 0,
                                        "compensacion": 0,
                                        "valoresContaminantes": {
                                            "S-BEN": 0,
                                            "S-TOL": 0,
                                            "S-ETI": 0,
                                            "S-IND": 0,
                                            "S-XIL": 0,
                                            "S-BENZ": 0,
                                            "S-DIB": 0,
                                            "S-BENA": 0,
                                            "S-BENB": 0,
                                            "S-NIQ": 0,
                                            "S-ARS": 0,
                                            "S-BENK": 0,
                                            "S-BAR": 0,
                                            "S-BER": 0,
                                            "S-CAD": 0,
                                            "S-CRO": 0,
                                            "S-MER": 0,
                                            "S-PLA": 0,
                                            "S-PLO": 0,
                                            "S-SEL": 0,
                                            "S-TAL": 0,
                                            "S-VAN": 0,
                                            "A-SST": 0,
                                            "A-GRAC": 0,
                                            "A-DBO": 0,
                                            "A-NIT": 0,
                                            "A-FOS": 0,
                                            "A-ARS": 0,
                                            "A-CAD": 0,
                                            "A-CIA": 0,
                                            "A-COB": 0,
                                            "A-CRO": 0,
                                            "A-MER": 0,
                                            "A-NIQ": 0,
                                            "A-PLO": 0,
                                            "A-ZIN": 0
                                        }
                                    },
                                    "estadoCuenta": {
                                        "loteId": 3941530,
                                        "tramiteId": 9798748,
                                        "serie": 2023,
                                        "identificador": 114717,
                                        "fechaVencimiento": "2023-09-09",
                                        "referencias": [
                                            {
                                                "referencia": "202300011471739766260",
                                                "recaudacion": "BANAMEX-005/01"
                                            }
                                        ]
                                    },
                                    "conceptos": [
                                        {
                                            "conceptoId": 40,
                                            "clave": "30542",
                                            "descripcion": "IMPUESTO A LA EMISION DE CONTAMINANTES AL SUELO, SUBSUELO Y AGUA",
                                            "tipoMovimiento": "IECSA",
                                            "importe": 1161.89
                                        }
                                    ]
                                }
                        */
                        setCalculoData(dataRec.response) //---- de aqui neceistamos tomar la referencia para generar la liga.
                        setCalculo(dataRec.response)
                        //updateData({ ...data, infoRFC: infoRFC, declaracionesImp: declaracionesImp, calculo: dataRec.response })
                    }


                },
                error: (error) => {
                    console.error('Subscription error', error);
                },
            });

        return () => {
            subscription.unsubscribe();
        };
    }, []);
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());


    const AlertsAction = (type) => {
        if (type === "error") {
            Swal.fire({
                title: 'Error!',
                text: 'Fallo el proceso de la creacion de pago',
                icon: 'error',
                confirmButtonText: 'Cerrar'
            })
        }
        if (type === "success") {
            Swal.fire({
                title: 'Liga generada con exito',
                text: 'La liga de pago se genero con exito.',
                icon: 'success',
                confirmButtonText: 'Aceptar'
            })
        }
    }

    const handleNext = () => {
        let newSkipped = skipped;


        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <>
            {/**
            {isLoading ?
                            <>
                                Loading
                                <Loader
                                />
                            </>
                            :
                            <>
                                Siguiente
                                <svg width="20" height="20" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23.4209 18.537C23.5726 18.3785 23.6915 18.1916 23.7709 17.987C23.9376 17.5813 23.9376 17.1261 23.7709 16.7204C23.6915 16.5158 23.5726 16.3289 23.4209 16.1704L18.4209 11.1704C18.107 10.8565 17.6814 10.6802 17.2375 10.6802C16.7937 10.6802 16.368 10.8565 16.0542 11.1704C15.7404 11.4842 15.5641 11.9098 15.5641 12.3537C15.5641 12.7975 15.7404 13.2232 16.0542 13.537L18.2209 15.687H12.2375C11.7955 15.687 11.3716 15.8626 11.059 16.1752C10.7465 16.4877 10.5709 16.9117 10.5709 17.3537C10.5709 17.7957 10.7465 18.2196 11.059 18.5322C11.3716 18.8448 11.7955 19.0204 12.2375 19.0204H18.2209L16.0542 21.1704C15.898 21.3253 15.774 21.5096 15.6894 21.7127C15.6048 21.9158 15.5612 22.1337 15.5612 22.3537C15.5612 22.5737 15.6048 22.7915 15.6894 22.9946C15.774 23.1977 15.898 23.3821 16.0542 23.537C16.2091 23.6932 16.3935 23.8172 16.5966 23.9018C16.7997 23.9865 17.0175 24.03 17.2375 24.03C17.4576 24.03 17.6754 23.9865 17.8785 23.9018C18.0816 23.8172 18.2659 23.6932 18.4209 23.537L23.4209 18.537ZM33.9042 17.3537C33.9042 14.0573 32.9267 10.835 31.0954 8.09418C29.264 5.35336 26.661 3.21715 23.6156 1.95569C20.5702 0.694233 17.219 0.364178 13.986 1.00726C10.753 1.65035 7.7833 3.2377 5.45242 5.56857C3.12155 7.89945 1.5342 10.8692 0.891115 14.1022C0.248028 17.3352 0.578083 20.6863 1.83954 23.7317C3.101 26.7772 5.23721 29.3802 7.97803 31.2115C10.7189 33.0429 13.9412 34.0204 17.2375 34.0204C21.6578 34.0204 25.897 32.2644 29.0226 29.1388C32.1483 26.0132 33.9042 21.774 33.9042 17.3537ZM3.9042 17.3537C3.9042 14.7166 4.68619 12.1387 6.15127 9.94608C7.61636 7.75343 9.69874 6.04446 12.1351 5.03529C14.5714 4.02612 17.2523 3.76208 19.8387 4.27655C22.4252 4.79102 24.8009 6.06089 26.6656 7.9256C28.5303 9.7903 29.8002 12.1661 30.3147 14.7525C30.8291 17.3389 30.5651 20.0198 29.5559 22.4561C28.5468 24.8925 26.8378 26.9749 24.6451 28.4399C22.4525 29.905 19.8746 30.687 17.2375 30.687C13.7013 30.687 10.3099 29.2823 7.80945 26.7818C5.30896 24.2813 3.9042 20.8899 3.9042 17.3537Z" fill="white" />
                                </svg>
                            </>

                        }
            */}
          {/*   <div className=''>
                <button onClick={declaracionesAnteriores}>Declaraciones</button>
                <button onClick={calculoImpuesto}>Calculo de Impuesto</button>
                <button onClick={GenerarLigaPago}>Liga de Pago</button>
                <button onClick={registroPagoSEI}>Registro de Pago</button>
                <button onClick={AlertsAction}>Mensajes</button>
                <button onClick={() => {
                    console.log(formik.values);
                }}>TestFormik</button>
               
            </div> */}
            <div className='HeaderTramite'>
                <View className='FormTitle'>Impuestos ecologicos - Emisión de contaminantes al suelo, subsuelo y agua</View>
                <View className='FormSubTitle'>--Emisión Contaminantes--.</View>
                <View className='FormDescripcion'>
                    A personas fisicas, personas morales, unidades economicas y entidades gubernamentales que generen
                    emisiones de gases de efecto invernadero en sus procesos productivos y operaciones dentro del
                    territorio del Estado de Durango, México.
                </View>
            </div>
            <View className='ViewPrincipal'>
                <View className='FormContent'>

                    <Form noValidate onSubmit={formik.handleSubmit} className='ViewActa'>
                        <Box sx={{ width: '100%' }}>
                            <Stepper activeStep={activeStep}>
                                {steps.map((label, index) => {
                                    const stepProps = {};
                                    const labelProps = {};


                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel  {...labelProps}>{label}</StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>
                            {activeStep === steps.length ? (
                                <React.Fragment>
                                    <Typography sx={{ mt: 2, mb: 1 }}>
                                        <label>Descripcion: Pulsa el boton para generar tu orden de pago.</label>
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }} style={{ justifyContent: "space-between" }}>
                                        <ButtonB
                                            variant='secondary'
                                            disabled={activeStep === 0}
                                            onClick={handleBack}

                                        >
                                            Anterior
                                        </ButtonB>

                                        <ButtonB type='submit' variant='secondary'>
                                            Enviar
                                        </ButtonB>
                                    </Box>
                                </React.Fragment>
                            ) : (
                                <React.Fragment >
                                    {activeStep === 0 ?
                                        <>

                                            <Row className="mb-3 mt-3">
                                                <Form.Group
                                                    as={Col}
                                                    controlId="validationFormikRFC"
                                                    className="position-relative"
                                                >
                                                    <Form.Label >
                                                        RFC*
                                                    </Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            name="RFC"
                                                            value={formik.values.RFC}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.RFC && !formik.errors.RFC}
                                                            isInvalid={!!formik.errors.RFC && formik.touched.RFC}
                                                        />
                                                        <Form.Control.Feedback type="invalid" tooltip>
                                                            {formik.errors.RFC}
                                                        </Form.Control.Feedback>
                                                        <ButtonB variant='secondary' onClick={() => validarRFC(formik.values.RFC)}>Validar RFC</ButtonB>
                                                    </InputGroup>
                                                </Form.Group>

                                            </Row>


                                            <Row className='mb-3'>
                                                <Form.Group
                                                    as={Col}
                                                    controlId="validationFormik102"
                                                    className="position-relative"
                                                >
                                                    <Form.Label > Año*</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="anno"
                                                        value={formik.values.anno}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.anno && !formik.errors.anno}
                                                        isInvalid={!!formik.errors.anno && formik.touched.anno}
                                                    />

                                                    <Form.Control.Feedback type="invalid" tooltip>{formik.errors.anno}</Form.Control.Feedback>
                                                </Form.Group>

                                            </Row>
                                            <Row className="mb-3">

                                                <Form.Group
                                                    as={Col}
                                                    controlId="validationFormik102"
                                                    className="position-relative"
                                                >
                                                    <Form.Label > Mes Inicio*</Form.Label>
                                                    <Form.Select

                                                        name="MesInicio"
                                                        value={formik.values.MesInicio}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.MesInicio && !formik.errors.MesInicio}
                                                        isInvalid={!!formik.errors.MesInicio && formik.touched.MesInicio}

                                                    >
                                                        <option>Seleccione...</option>
                                                        <option value={1}>Enero</option>
                                                        <option value={2}>Febrero</option>
                                                        <option value={3}>Marzo</option>
                                                        <option value={4}>Abril</option>
                                                        <option value={5}>Mayo</option>
                                                        <option value={6}>Junio</option>
                                                        <option value={7}>Julio</option>
                                                        <option value={8}>Agosto</option>
                                                        <option value={9}>Septiembre</option>
                                                        <option value={10}>Octubre</option>
                                                        <option value={11}>Noviembre</option>
                                                        <option value={12}>Diciembre</option>
                                                    </Form.Select>

                                                    <Form.Control.Feedback type="invalid" tooltip>{formik.errors.MesInicio}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group
                                                    as={Col}
                                                    controlId="validationFormik102"
                                                    className="position-relative"
                                                >
                                                    <Form.Label > Mes Fin*</Form.Label>
                                                    <Form.Select

                                                        name="MesFinal"
                                                        value={formik.values.MesFinal}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.MesFinal && !formik.errors.MesFinal}
                                                        isInvalid={!!formik.errors.MesFinal && formik.touched.MesFinal}

                                                    >
                                                        <option>Seleccione...</option>
                                                        <option value={1}>Enero</option>
                                                        <option value={2}>Febrero</option>
                                                        <option value={3}>Marzo</option>
                                                        <option value={4}>Abril</option>
                                                        <option value={5}>Mayo</option>
                                                        <option value={6}>Junio</option>
                                                        <option value={7}>Julio</option>
                                                        <option value={8}>Agosto</option>
                                                        <option value={9}>Septiembre</option>
                                                        <option value={10}>Octubre</option>
                                                        <option value={11}>Noviembre</option>
                                                        <option value={12}>Diciembre</option>
                                                    </Form.Select>

                                                    <Form.Control.Feedback type="invalid" tooltip>{formik.errors.MesFinal}</Form.Control.Feedback>
                                                </Form.Group>

                                            </Row>
                                            {/***DECLARACIONES ANterkiores */}
                                            <Row className='mb-3'>
                                                <ButtonB onClick={() => declaracionesAnteriores(formik.values)} style={{ width: "50%", margin: "auto" }} variant='secondary'>Declaracion</ButtonB>
                                            </Row>
                                            <Row>
                                                <ul style={{listStyle:"none", display:"grid", gridTemplateColumns:"1fr 1fr", gap:"1rem"}}>

                                                {declaracionesImp.length !== 0 && declaracionesImp.map((dec, index) => {
                                                    return (<li key={index} style={{display:"grid", gridTemplateColumns:"1fr", padding:"1rem", backgroundColor:"lightgray", borderRadius:"1rem"}}>
                                                        <span style={{display:"flex", justifyContent:"space-between"}}> Numero: <label>{dec.mdCaracteristicasImpId}</label></span>
                                                        <span style={{display:"flex", justifyContent:"space-between"}}>Periodo: <label>{dec.periodo}</label></span>
                                                        <span style={{display:"flex", justifyContent:"space-between"}}>Fecha de declaración: <label>{dec.fechaDeclaracion}</label></span>
                                                        <span style={{display:"flex", justifyContent:"space-between"}}>Total: <label>{dec.total}</label></span>
                                                        </li>)
                                                })}
                                                </ul>
                                            </Row>
                                            <Row className='mb-3'>
                                                <Form.Group as={Col} className='position-relative'>
                                                    <Form.Label >
                                                        Compensación
                                                    </Form.Label>
                                                    <Form.Control
                                                        type='number'
                                                        placeholder='Cantidad'
                                                        name='Compensacion'
                                                        value={formik.values.Compensacion}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.Compensacion && !formik.errors.Compensacion}
                                                        isInvalid={!!formik.errors.Compensacion && formik.touched.Compensacion}
                                                    />
                                                    <Form.Control.Feedback type='invalid' tooltip>{formik.errors.Compensacion}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} className='position-relative'>
                                                    <Form.Label >
                                                        Saldo a Favor
                                                    </Form.Label>
                                                    <Form.Control
                                                        type='number'
                                                        placeholder='Cantidad'
                                                        name='SaldoFavor'
                                                        value={formik.values.SaldoFavor}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.SaldoFavor && !formik.errors.SaldoFavor}
                                                        isInvalid={!!formik.errors.SaldoFavor && formik.touched.SaldoFavor}
                                                    />
                                                    <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SaldoFavor}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                            <Row className='mb-3'>
                                                <Form.Group as={Col} className='position-relative'>
                                                    <Form.Label >Multas</Form.Label>
                                                    <Form.Control
                                                        type='number'
                                                        placeholder='Cantidad'
                                                        name='Multas'
                                                        value={formik.values.Multas}
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.Multas && !formik.errors.Multas}
                                                        isInvalid={!!formik.errors.Multas && formik.touched.Multas}
                                                    />
                                                    <Form.Control.Feedback type='invalid' tooltip>{formik.errors.Multas}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                            <Row className='mb-3'>
                                                <ButtonB type='submit' style={{ width: "50%", margin: "auto" }} variant='secondary'>Validar</ButtonB>
                                            </Row>
                                        </>

                                        :
                                        activeStep === 1 ?
                                            <>
                                                <Row className='mb-3 mt-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Metros Cuadrados Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='metrosCuadradosSuelo'
                                                            value={formik.values.metrosCuadradosSuelo}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.metrosCuadradosSuelo && !formik.errors.metrosCuadradosSuelo}
                                                            isInvalid={!!formik.errors.metrosCuadradosSuelo && formik.touched.metrosCuadradosSuelo}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.metrosCuadradosSuelo}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Benceno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBen'
                                                            value={formik.values.SBen}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBen && !formik.errors.SBen}
                                                            isInvalid={!!formik.errors.SBen && formik.touched.SBen}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBen}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Tolueno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='STol'
                                                            value={formik.values.STol}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.STol && !formik.errors.STol}
                                                            isInvalid={!!formik.errors.STol && formik.touched.STol}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.STol}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Etilbenceno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SEti'
                                                            value={formik.values.SEti}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SEti && !formik.errors.SEti}
                                                            isInvalid={!!formik.errors.SEti && formik.touched.SEti}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SEti}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Indeno Pireno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SInd'
                                                            value={formik.values.SInd}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SInd && !formik.errors.SInd}
                                                            isInvalid={!!formik.errors.SInd && formik.touched.SInd}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SInd}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Xilenos Suma de Isómeros en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SXil'
                                                            value={formik.values.SXil}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SXil && !formik.errors.SXil}
                                                            isInvalid={!!formik.errors.SXil && formik.touched.SXil}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SXil}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Benzo Ireno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBenz'
                                                            value={formik.values.SBenz}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBenz && !formik.errors.SBenz}
                                                            isInvalid={!!formik.errors.SBenz && formik.touched.SBenz}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBenz}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Dibenzo Antraceno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SDib'
                                                            value={formik.values.SDib}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SDib && !formik.errors.SDib}
                                                            isInvalid={!!formik.errors.SDib && formik.touched.SDib}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SDib}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Benzo Antraceno en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBena'
                                                            value={formik.values.SBena}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBena && !formik.errors.SBena}
                                                            isInvalid={!!formik.errors.SBena && formik.touched.SBena}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBena}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Benzo Fluoranteno (b) en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBenb'
                                                            value={formik.values.SBenb}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBenb && !formik.errors.SBenb}
                                                            isInvalid={!!formik.errors.SBenb && formik.touched.SBenb}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBenb}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Niquel en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SNiq'
                                                            value={formik.values.SNiq}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SNiq && !formik.errors.SNiq}
                                                            isInvalid={!!formik.errors.SNiq && formik.touched.SNiq}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SNiq}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Arsénico en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SArs'
                                                            value={formik.values.SArs}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SArs && !formik.errors.SArs}
                                                            isInvalid={!!formik.errors.SArs && formik.touched.SArs}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SArs}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Benzo Fluoranteno (k) en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBenk'
                                                            value={formik.values.SBenk}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBenk && !formik.errors.SBenk}
                                                            isInvalid={!!formik.errors.SBenk && formik.touched.SBenk}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBenk}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Bario en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBar'
                                                            value={formik.values.SBar}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBar && !formik.errors.SBar}
                                                            isInvalid={!!formik.errors.SBar && formik.touched.SBar}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBar}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Berilio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SBer'
                                                            value={formik.values.SBer}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SBer && !formik.errors.SBer}
                                                            isInvalid={!!formik.errors.SBer && formik.touched.SBer}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SBer}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Cadmio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SCad'
                                                            value={formik.values.SCad}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SCad && !formik.errors.SCad}
                                                            isInvalid={!!formik.errors.SCad && formik.touched.SCad}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SCad}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Cromo Hexavalente en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SCro'
                                                            value={formik.values.SCro}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SCro && !formik.errors.SCro}
                                                            isInvalid={!!formik.errors.SCro && formik.touched.SCro}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SCro}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Mercurio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SMer'
                                                            value={formik.values.SMer}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SMer && !formik.errors.SMer}
                                                            isInvalid={!!formik.errors.SMer && formik.touched.SMer}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SMer}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Plata en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SPla'
                                                            value={formik.values.SPla}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SPla && !formik.errors.SPla}
                                                            isInvalid={!!formik.errors.SPla && formik.touched.SPla}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SPla}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Plomo en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SPlo'
                                                            value={formik.values.SPlo}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SPlo && !formik.errors.SPlo}
                                                            isInvalid={!!formik.errors.SPlo && formik.touched.SPlo}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SPlo}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Selenio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SSel'
                                                            value={formik.values.SSel}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SSel && !formik.errors.SSel}
                                                            isInvalid={!!formik.errors.SSel && formik.touched.SSel}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SSel}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                                <Row className='mb-3'>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Talio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='STal'
                                                            value={formik.values.STal}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.STal && !formik.errors.STal}
                                                            isInvalid={!!formik.errors.STal && formik.touched.STal}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.STal}</Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} className='position-relative'>
                                                        <Form.Label >
                                                            Vanadio en Suelo
                                                        </Form.Label>
                                                        <Form.Control
                                                            type='number'
                                                            placeholder='Cantidad'
                                                            name='SVan'
                                                            value={formik.values.SVan}
                                                            onChange={formik.handleChange}
                                                            isValid={formik.touched.SVan && !formik.errors.SVan}
                                                            isInvalid={!!formik.errors.SVan && formik.touched.SVan}
                                                        />
                                                        <Form.Control.Feedback type='invalid' tooltip>{formik.errors.SVan}</Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                            </>
                                            :
                                            activeStep === 2 ?
                                                <>
                                                    <Row className='mb-3 mt-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Metros Cúbicos de agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='metrosCubicosAgua'
                                                                value={formik.values.metrosCubicosAgua}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.metrosCubicosAgua && !formik.errors.metrosCubicosAgua}
                                                                isInvalid={!!formik.errors.metrosCubicosAgua && formik.touched.metrosCubicosAgua}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.metrosCubicosAgua}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Sólidos Suspendidos en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ASst'
                                                                value={formik.values.ASst}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ASst && !formik.errors.ASst}
                                                                isInvalid={!!formik.errors.ASst && formik.touched.ASst}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ASst}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Grasa Aceites en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='AGrac'
                                                                value={formik.values.AGrac}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.AGrac && !formik.errors.AGrac}
                                                                isInvalid={!!formik.errors.AGrac && formik.touched.AGrac}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.AGrac}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                D. Bioquímoca de Oxígeno 5 en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ADbo'
                                                                value={formik.values.ADbo}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ADbo && !formik.errors.ADbo}
                                                                isInvalid={!!formik.errors.ADbo && formik.touched.ADbo}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ADbo}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Nitrógeno Total en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ANit'
                                                                value={formik.values.ANit}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ANit && !formik.errors.ANit}
                                                                isInvalid={!!formik.errors.ANit && formik.touched.ANit}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ANit}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                25 Fósforo Total en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='AFos'
                                                                value={formik.values.AFos}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.AFos && !formik.errors.AFos}
                                                                isInvalid={!!formik.errors.AFos && formik.touched.AFos}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.AFos}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Arsénico en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='AArs'
                                                                value={formik.values.AArs}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.AArs && !formik.errors.AArs}
                                                                isInvalid={!!formik.errors.AArs && formik.touched.AArs}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.AArs}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Cadmio en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ACad'
                                                                value={formik.values.ACad}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ACad && !formik.errors.ACad}
                                                                isInvalid={!!formik.errors.ACad && formik.touched.ACad}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ACad}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Cianuro en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ACia'
                                                                value={formik.values.ACia}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ACia && !formik.errors.ACia}
                                                                isInvalid={!!formik.errors.ACia && formik.touched.ACia}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ACia}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Cobre en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ACob'
                                                                value={formik.values.ACob}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ACob && !formik.errors.ACob}
                                                                isInvalid={!!formik.errors.ACob && formik.touched.ACob}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ACob}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Cromo en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ACro'
                                                                value={formik.values.ACro}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ACro && !formik.errors.ACro}
                                                                isInvalid={!!formik.errors.ACro && formik.touched.ACro}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ACro}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Mercurio en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='AMer'
                                                                value={formik.values.AMer}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.AMer && !formik.errors.AMer}
                                                                isInvalid={!!formik.errors.AMer && formik.touched.AMer}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.AMer}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Níquel en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='ANiq'
                                                                value={formik.values.ANiq}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.ANiq && !formik.errors.ANiq}
                                                                isInvalid={!!formik.errors.ANiq && formik.touched.ANiq}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.ANiq}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-3'>

                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Plomo en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='APlo'
                                                                value={formik.values.APlo}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.APlo && !formik.errors.APlo}
                                                                isInvalid={!!formik.errors.APlo && formik.touched.APlo}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.APlo}</Form.Control.Feedback>
                                                        </Form.Group>
                                                        <Form.Group as={Col} className='position-relative'>
                                                            <Form.Label >
                                                                Zinc en agua
                                                            </Form.Label>
                                                            <Form.Control
                                                                type='number'
                                                                placeholder='Cantidad'
                                                                name='AZin'
                                                                value={formik.values.AZin}
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.AZin && !formik.errors.AZin}
                                                                isInvalid={!!formik.errors.AZin && formik.touched.AZin}
                                                            />
                                                            <Form.Control.Feedback type='invalid' tooltip>{formik.errors.AZin}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Row>
                                                    {/*    <Row className="mb-3">
                                                                <Form.Group as={Col} className="d-grid gap-2">
                                                                    <Text>Descripcion: Pulsa el boton para generar tu orden de pago.</Text>
                                                                    <Button type="submit" style={{ backgroundColor: "#607472", color: "white" }} isDisabled={isLoading}>
                                                                        {isLoading ?
                                                                            <>
                                                                                Loading
                                                                                <Loader
                                                                                />
                                                                            </>
                                                                            :
                                                                            <>
                                                                                Siguiente
                                                                                <svg width="20" height="20" viewBox="0 0 34 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M23.4209 18.537C23.5726 18.3785 23.6915 18.1916 23.7709 17.987C23.9376 17.5813 23.9376 17.1261 23.7709 16.7204C23.6915 16.5158 23.5726 16.3289 23.4209 16.1704L18.4209 11.1704C18.107 10.8565 17.6814 10.6802 17.2375 10.6802C16.7937 10.6802 16.368 10.8565 16.0542 11.1704C15.7404 11.4842 15.5641 11.9098 15.5641 12.3537C15.5641 12.7975 15.7404 13.2232 16.0542 13.537L18.2209 15.687H12.2375C11.7955 15.687 11.3716 15.8626 11.059 16.1752C10.7465 16.4877 10.5709 16.9117 10.5709 17.3537C10.5709 17.7957 10.7465 18.2196 11.059 18.5322C11.3716 18.8448 11.7955 19.0204 12.2375 19.0204H18.2209L16.0542 21.1704C15.898 21.3253 15.774 21.5096 15.6894 21.7127C15.6048 21.9158 15.5612 22.1337 15.5612 22.3537C15.5612 22.5737 15.6048 22.7915 15.6894 22.9946C15.774 23.1977 15.898 23.3821 16.0542 23.537C16.2091 23.6932 16.3935 23.8172 16.5966 23.9018C16.7997 23.9865 17.0175 24.03 17.2375 24.03C17.4576 24.03 17.6754 23.9865 17.8785 23.9018C18.0816 23.8172 18.2659 23.6932 18.4209 23.537L23.4209 18.537ZM33.9042 17.3537C33.9042 14.0573 32.9267 10.835 31.0954 8.09418C29.264 5.35336 26.661 3.21715 23.6156 1.95569C20.5702 0.694233 17.219 0.364178 13.986 1.00726C10.753 1.65035 7.7833 3.2377 5.45242 5.56857C3.12155 7.89945 1.5342 10.8692 0.891115 14.1022C0.248028 17.3352 0.578083 20.6863 1.83954 23.7317C3.101 26.7772 5.23721 29.3802 7.97803 31.2115C10.7189 33.0429 13.9412 34.0204 17.2375 34.0204C21.6578 34.0204 25.897 32.2644 29.0226 29.1388C32.1483 26.0132 33.9042 21.774 33.9042 17.3537ZM3.9042 17.3537C3.9042 14.7166 4.68619 12.1387 6.15127 9.94608C7.61636 7.75343 9.69874 6.04446 12.1351 5.03529C14.5714 4.02612 17.2523 3.76208 19.8387 4.27655C22.4252 4.79102 24.8009 6.06089 26.6656 7.9256C28.5303 9.7903 29.8002 12.1661 30.3147 14.7525C30.8291 17.3389 30.5651 20.0198 29.5559 22.4561C28.5468 24.8925 26.8378 26.9749 24.6451 28.4399C22.4525 29.905 19.8746 30.687 17.2375 30.687C13.7013 30.687 10.3099 29.2823 7.80945 26.7818C5.30896 24.2813 3.9042 20.8899 3.9042 17.3537Z" fill="white" />
                                                                                </svg>
                                                                            </>

                                                                        }
                                                                     </Button>
                                                                </Form.Group>
                                                            </Row>


                                                            <Row className="mb-3">
                                                                <Form.Group as={Col} className="d-grid gap-2">
                                                                    <Button type="button" variation="secondary">
                                                                        Regresar
                                                                    </Button>
                                                                </Form.Group>

                                                            </Row> */}
                                                </>

                                                :
                                                activeStep === 3 ?

                                                    <FormPagos metodoPago={metodoPago} setMetodoPago={setMetodoPago} />

                                                    :
                                                    null

                                    }
                                    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                        <ButtonB
                                            variant='secondary'
                                            disabled={activeStep === 0}
                                            onClick={handleBack}


                                        >
                                            Anterior
                                        </ButtonB>
                                        <Box sx={{ flex: '1 1 auto' }} />


                                        <ButtonB onClick={() => {
                                            if (activeStep === steps.length - 1) {
                                                GenerarLigaPago()
                                                return
                                            }
                                            handleNext()
                                        }} variant='secondary'>
                                            {activeStep === steps.length - 1 ? 'Terminar' : 'Siguiente'}
                                        </ButtonB>
                                    </Box>
                                </React.Fragment>
                            )}
                        </Box>




                    </Form>

                </View>

            </View>
            <ResumenCard calculoImp={calculoImpuesto} />
            <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={loading}

                >
                    <h1>Esperando Respuesta</h1>
                    <CircularProgress color="inherit" />
                </Backdrop>
        </>
    )
}
